











import {Component, Vue} from "vue-property-decorator";
import Login from "@/views/Guest/Login.vue";
@Component({
    components: {
      Login
    }
})
export default class GuestLayout extends Vue {
        created() {
           //console.log(this.$store.state.layoutName == this.constructor.name);
        }
}
